import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/useStore";
import Loading from "./Loading";

function PrivateRoute({ children }) {
  const { isAuthenticated, checkAuth } = useAuthStore();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const initializeAuth = async () => {
      await checkAuth();
      setIsChecking(false);
    };

    initializeAuth();
  }, [checkAuth]);

  // 인증 상태 확인 중일 때 로딩 표시
  if (isChecking) {
    return <Loading />;
  }

  // 인증되지 않은 경우 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 인증된 경우 자식 컴포넌트 렌더링
  return children;
}

export default PrivateRoute;
